import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PageWrapper, Loader, Alert, Pagination } from '../../components';
import Actions, { thunks } from '../../redux/modules/orders';
import Details from './components/details';
import { ORDER_STATUS } from '../../constants';
import { formatIsoDate } from '../../utils/format';
import { debounce } from 'lodash';


class Orders extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(thunks.getOrders());
  }

  onSearchTextChange = debounce((e) => {
    const { value } = e.target ? e.target : "";
    const { updateProperty, dispatch } = this.props;
    updateProperty("searchText", value);
    if (value) {
      dispatch(thunks.searchOrders(value));
    } else {
      dispatch(thunks.getOrders());
    }
  }, 300);

  viewOrder = (order) => {
    const { dispatch, updateProperty } = this.props;
    dispatch(thunks.getOrderDetails(order.id));
    updateProperty("showDetails", true);
  };

  onNext = () => {
    const { dispatch } = this.props;
    dispatch(thunks.loadMoreOrders());
  };

  closeDetailsModal = () => {
    const { updateProperty } = this.props;
    updateProperty("showDetails", false);
    updateProperty("data", {});
  };

  onStatusChange = (e) => {
    e.preventDefault();
    const { dispatch, updateProperty } = this.props;
    updateProperty("status", e.target.value);
    dispatch(thunks.getOrders());
  };

  updateStatus = (request) => {
    const { dispatch } = this.props;
    dispatch(thunks.updateStatus(request));
  };

  render() {
    const {
      list,
      loading,
      error,
      updateProperty,
      nextPageToken,
      showDetails,
      data,
      loadingData,
      status,
    } = this.props;
    return (
      <PageWrapper title="Orders List">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Orders"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Search</label>
                        <input
                          placeholder="Enter search text"
                          className="form-control"
                          onChange={this.onSearchTextChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          className="form-control"
                          value={status}
                          onChange={this.onStatusChange}
                        >
                          {ORDER_STATUS.map((status) => (
                            <option key={status.value} value={status.value}>
                              {status.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Phone Number</th>
                          <th>Total Cost</th>
                          <th>Paid Amount</th>
                          <th>Balance Amount</th>
                          <th>Address</th>
                          <th>Gst</th>
                          <th>Ordered On</th>
                          <th>Status</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((order) => (
                            <tr key={order.id}>
                              <td>{order.id}</td>

                              <td>{order.user?.name}</td>
                              <td>{order.user?.phoneNumber}</td>
                              <td>{order.orderTotal}</td>
                              <td>{order.amountPaid}</td>
                              <td>{order.orderTotal - order.amountPaid}</td>
                              <td>
                                {order.address?.nickName || ""}{" "}
                                {order.address.addressLineOne || ""}{" "}
                                {order.address?.pincode || ""}
                              </td>
                              <td>{order.address?.gst || 0}</td>
                              <td>{formatIsoDate(order.createdOn)}</td>
                              <td className="text-capitalize">
                                {order.status}
                              </td>
                              <td>
                                <button
                                  title="View Order"
                                  className="btn btn-xs btn-info"
                                  onClick={() => this.viewOrder(order)}
                                >
                                  <i className="fa fa-eye" />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    nextPageToken={nextPageToken}
                    onNext={this.onNext}
                  />
                  <Details
                    show={showDetails}
                    data={data}
                    loading={loadingData}
                    onHide={this.closeDetailsModal}
                    updateStatus={this.updateStatus}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
    orders: {
        loading,
        error,
        list,
        nextPageToken,
        showDetails,
        data,
        loadingData,
        status,
    },
}) => ({
    loading,
    error,
    list,
    nextPageToken,
    showDetails,
    data,
    loadingData,
    status,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders)